import BaseApi from '@/api/index'

class ThemeService {
    constructor() {
      this.currentTheme = null
      this.portal_api = BaseApi
      this.cache = new Map()
      this.CACHE_KEY = 'quiz_theme_cache'
      this.CACHE_TTL = 30 * 60 * 1000 // 30 минут
    }
  
    // Загрузка метаданных темы
    async loadTheme(streamSlug) {
      if (this.cache.has(streamSlug)) {
        const cached = this.cache.get(streamSlug)
        if (Date.now() - cached.timestamp < this.CACHE_TTL) {
          return cached.data
        }
      }
  
      try {
        const streams_data = await this.portal_api.getAvailableStreamList()
        const streamData = streams_data.find(stream => stream.slug === streamSlug)
        const themeData = streamData.meta['portal_theme']

        
        this.cache.set(streamSlug, {
          data: themeData,
          timestamp: Date.now()
        })
        
        return themeData
      } catch (error) {
        console.error('Failed to load theme:', error)
        return null
      }
    }
  
    // Подключение CSS-файла
    loadCSS(cssUrl, themeId) {

      // Удаляем предыдущую тему
      this.unloadCSS()
      
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = cssUrl
      link.id = `theme-${themeId}`
      link.setAttribute('data-theme', themeId)
      
      // Обработка загрузки
      link.onload = () => {
        console.log(`Theme ${themeId} loaded successfully`)
      }
      console.log('CSS URL', cssUrl)
      
      link.onerror = () => {
        console.error(`Failed to load theme ${themeId}`)
        this.unloadCSS()
      }
      
      document.head.appendChild(link)
      this.currentTheme = { cssUrl, themeId }
    }
  
    // Удаление CSS-файла
    unloadCSS() {
      const existingLink = document.querySelector('[data-theme]')
      if (existingLink) {
        existingLink.remove()
      }
      this.currentTheme = null
    }

    // setBackground(bgImageUrl, streamSlug) {
    //     document.body.style.backgroundImage = `url(${bgImageUrl})`
    //     document.body.style.backgroundSize = 'cover'           // Покрывает весь экран
    //     document.body.style.backgroundPosition = 'center'      // Центрирует
    //     document.body.style.backgroundRepeat = 'no-repeat'     // Без повторения
    //     document.body.style.backgroundAttachment = 'fixed'     // Фиксированный фон (не следует за прокруткой)
    //     document.body.style.minHeight = '100vh'                // Минимальная высота на весь экран
    //     document.body.setAttribute('data-stream', streamSlug)
    //     const homeHeader = document.querySelector('.homeHeader')
    //     homeHeader.style.backgroundImage = 'none'
    //   }

    setBackground(bgImageUrl, streamSlug) {
      let bg = document.querySelector('.fixed-bg')
      if (!bg) {
        bg = document.createElement('div')
        bg.classList.add('fixed-bg')
        document.body.prepend(bg)
      }

      bg.style.backgroundImage = `url(${bgImageUrl})`
      bg.style.backgroundSize = 'cover'
      bg.style.backgroundPosition = 'center'
      bg.style.backgroundRepeat = 'no-repeat'
      bg.style.position = 'fixed'
      bg.style.top = '0'
      bg.style.left = '0'
      bg.style.width = '100%'
      bg.style.height = '100%'
      bg.style.zIndex = '-1'
      bg.style.transform = 'translateZ(0)'
      
      document.body.setAttribute('data-stream', streamSlug)

      // const homeHeader = document.querySelector('.homeHeader')
      // if (homeHeader) homeHeader.style.backgroundImage = 'none'
    }

  
    // Очистка фона
    // clearBackground() {
    //   document.body.style.backgroundImage = ''
    //   document.body.style.backgroundSize = ''
    //   document.body.style.backgroundPosition = ''
    //   document.body.style.backgroundRepeat = ''
    //   document.body.removeAttribute('data-stream')
    // }

    clearBackground() {
      let bg = document.querySelector('.fixed-bg')

      bg.style.backgroundImage = ``
      bg.style.backgroundSize = ''
      bg.style.backgroundPosition = ''
      bg.style.backgroundRepeat = ''
      bg.style.position = ''
      bg.removeAttribute('data-stream')
    }
  
    // Основной метод активации темы
    async activateTheme(streamSlug) {
      try {
        const themeData = await this.loadTheme(streamSlug)
        if (!themeData) return false
  
        // Подключаем CSS
        if (themeData.cssUrl) {
          this.loadCSS(themeData.cssUrl, streamSlug)
        }
  
        // Применяем фон
        if (themeData.bgImageUrl) {
          this.setBackground(themeData.bgImageUrl, streamSlug)
        }
  
        return true
      } catch (error) {
        console.error('Failed to activate theme:', error)
        return false
      }
    }
  
    // Деактивация темы
    deactivateTheme() {
      this.unloadCSS()
      this.clearBackground()
    }
  }
  
  export default new ThemeService()